import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: localStorage.getItem('token') || null,
      userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
      showLoginDialog: false
    }
  },
  getters: {
    getToken(state) {
      return state.token || localStorage.getItem('token')
    },
    getUserInfo() {
      return this.userInfo || JSON.parse(localStorage.getItem('userInfo') || 'null') // 可以使用this访问到整个store实例
    }
  },
  actions: {
    setToken(val) {
      this.token = val
      localStorage.setItem('token', val)
    },
    setUserInfo(val) {
      this.userInfo = val
      localStorage.setItem('userInfo', JSON.stringify(val))
    },
    openLoginDialog() {
      this.showLoginDialog = true
    },
    closeLoginDialog() {
      this.showLoginDialog = false
    }
  }
})
